import { i18n } from "../../i18n/i18n";

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { connect, ConnectedProps } from 'react-redux'
import { RootState } from '../../store'
import routes from '../../routes/routes'
import confirmService from '../../services/confirm.service'
import { ConfirmParams } from '../../components/Confirm/Confirm.state'
import { replacePage, replaceLimit, replaceSearch } from './Items.slice'
import { paginate, deleteItem } from './Items.thunk'
import Button from '../../components/Button'
import Card from '../../components/Card'
import ContentLayout from '../../components/ContentLayout'
import ContentMain from '../../components/ContentMain'
import DataTable from '../../components/DataTable'
import HeadingRow from '../../components/HeadingRow'
import { TableHorizontalHeader } from '../../components/TableHorizontal'
import { ActionName } from '../../components/Actions'

interface ItemsProps
  extends RouteComponentProps, ConnectedProps<typeof connector> {}

class Items extends Component<ItemsProps> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n("Item code"), path: 'code' },
    { heading: i18n("Description"), path: 'description' },
    { heading: i18n("Category"), path: 'category.name' },
    { heading: i18n("CPP"), path: 'cpp' },
    { heading: i18n("QPC"), path: 'qpc' },
    { heading: i18n("Packs per case (PPC)"), path: 'cpb' },
    { heading: i18n("Net weight"), path: 'netWeight' },
    { heading: i18n("Gross weight"), path: 'grossWeight' },
    { heading: i18n("Updated at"),
      path: 'updatedAt',
      date: true,
      tooltip: ['updatedUser.username', '-', 'updatedUser.site.name']
    },
    { heading: i18n("Actions") }
  ]

  constructor (props: ItemsProps) {
    super(props)
    this.handleLimitChange = this.handleLimitChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handlePaginate = this.handlePaginate.bind(this)
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleLimitChange (limit: string) {
    this.props.replaceLimit(Number(limit))
  }

  handleSearch (search: string) {
    this.props.replaceSearch(search)
  }

  handlePaginate (page: number) {
    this.props.replacePage(page)
  }

  handleCreateClick () {
    this.props.history.push(routes.itemCreate)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = routes.itemEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'delete') {
      const confirm: ConfirmParams = {
        id,
        type: 'warning',
        question: i18n('Are you sure to delete the item?'),
        confirmText: i18n('Yes'),
        cancelText: i18n('No'),
        onConfirm: () => this.props.deleteItem(id)
      }
      confirmService.push(confirm)
    }
  }

  componentDidMount () {
    this.props.paginate()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="full">
          <Card>
            <HeadingRow
              heading={i18n("Items")}
              doc='items'>
              <Button
                text={i18n("Create")}
                onClick={this.handleCreateClick} />
            </HeadingRow>
            <DataTable
              headers={this.headers}
              data={this.props.data}
              total={this.props.total}
              from={this.props.from}
              to={this.props.to}
              currentPage={this.props.currentPage}
              lastPage={this.props.lastPage}
              limit={String(this.props.limit)}
              search={this.props.search}
              onLimtChange={this.handleLimitChange}
              onSearch={this.handleSearch}
              onPaginate={this.handlePaginate}
              onActionClick={this.handleActionClick} />
          </Card>
        </ContentMain>
      </ContentLayout>
    )
  }
}

const mapStateToProps = (state: RootState) => {
  const { result, limit, search } = state.items
  const { data, total, from, to, currentPage, lastPage } = result
  return { data, total, from, to, currentPage, lastPage, limit, search }
}

const mapDispatchToProps = {
  paginate,
  deleteItem,
  replacePage,
  replaceLimit,
  replaceSearch
}

const connector = connect(mapStateToProps, mapDispatchToProps)
export default connector(withRouter(Items))
